import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/Marquee";
import WhyUs from "@/components/WhyUs";
import Trailers from "@/components/Trailers";
import Gallery from "@/components/Gallery";
import About from "@/components/About";
import ServiceArea from "@/components/ServiceArea";
import Faq from "@/components/Faq";
import { ContactSection, QuoteSection } from "@/components/ContactQuote";
import Footer from "@/components/Footer";

export default function HomePage() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 300);
    }
  }, [location.hash]);

  return (
    <div data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <EditorialMarquee />
        <WhyUs />
        <Trailers />
        <Gallery />
        <About />
        <ServiceArea />
        <Faq />
        <QuoteSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
